// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2GTt5","infoBtn":"quickbooks_infoBtn__PsyxY","formBox":"quickbooks_formBox__nXtBz","formFooter":"quickbooks_formFooter__1RXA2"};